import React from "react";
import "./Process.css";
import { CgArrowLongRight } from "react-icons/cg";

const steps = [
  {
    number: 1,
    title: "Post & Distribute",
    desc: "Create a job posting once and automatically distribute it across multiple job boards and channels.",
  },
  {
    number: 2,
    title: "Source & Screen",
    desc: "Leverage AI to discover candidates, parse resumes, and quickly shortlist the most relevant profiles.",
  },
  {
    number: 3,
    title: "Evaluate & Interview",
    desc: "Use skill assessments, structured interviews, and video calls to fairly evaluate shortlisted candidates.",
  },
  {
    number: 4,
    title: "Decide & Onboard",
    desc: "Collaborate with hiring managers to finalize decisions and seamlessly onboard selected candidates.",
  },
];

const ProcessSection = () => {
  return (
    <section className="process-section">
      <h2 className="process-heading">Streamlined Hiring in 4 Steps</h2>
      <p className="process-subheading">
        Simplify your end-to-end recruitment process with AI-powered automation
        and collaborative workflows.
      </p>

      <div className="process-steps">
        {steps.map((step, index) => (
          <div key={step.number} className="process-step">
            <div className="process-card">
              <div className="circle">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
            {index < steps.length - 1 && (
              <CgArrowLongRight className="arrow-icon" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessSection;
